export enum Routes {
  DASHBOARD = "dashboard",
  ADS_OVERVIEW = "ads-overview",
  STORE = "store",
  OVERVIEW = "overview",
  PRODUCTS = "products",
  ORDERS = "orders",
  MARKETING = "marketing",
  FINANCE = "finance",
  LTV = "ltv",
  COHORTS = "cohorts",
  SETTINGS = "settings",
  COSTS = "costs",
  BUSINESS_COSTS = "business-costs",
  STAFF = "staff",
  EDIT_GOALS = "edit-goals",
  CONNECTIONS = "connections",
  NOTIFICATIONS = "notifications",
  TEAM = "team",
  ACCOUNT = "account",
  GOALS_WIZARD = "goals-wizard",
  CREATIVES = "creatives",
  FACEBOOK = "facebook",
  GOOGLE = "google",
  TIKTOK = "tiktok",
  KLAVIYO = "klaviyo",
  RECHARGE = "recharge",
  GOOGLE_ANALYTICS = "google-analytics",
  GOOGLE_ANALYTICS_4 = "google-analytics-4",
  SEO = "seo",
  LOGIN = "login",
  RECOVERY = "recovery",
  REGISTER = "register",
  ONBOARDING = "onboarding",
  GENERAL = "general",
  BRANDING = "branding",
  SHIPPING = "shipping",
  TRANSACTION_FEES = "transaction-fees",
  MARKETS = "markets",
  MARKETING_COSTS = "marketing-costs",
  OTHER_COSTS = "other-costs",
  DEFAULTS = "defaults",
  FULFILLMENT = "fulfillment",
}

export const routes = {
  // DASHBOARD
  dashboard: () => `/${Routes.DASHBOARD}`,
  // ADS_OVERVIEW
  adsOverview: () => `/${Routes.ADS_OVERVIEW}`,
  // STORE
  store: () => `/${Routes.STORE}`,
  storeOverview: () => `${routes.store()}/${Routes.OVERVIEW}`,
  storeProducts: () => `${routes.store()}/${Routes.PRODUCTS}`,
  storeOrders: () => `${routes.store()}/${Routes.ORDERS}`,
  // MARKETING
  marketing: () => `/${Routes.MARKETING}`,
  marketingCreative: () => `${routes.marketing()}/${Routes.CREATIVES}`,
  marketingCreativeOverview: () => `${routes.marketingCreative()}/${Routes.OVERVIEW}`,
  marketingFacebook: () => `${routes.marketing()}/${Routes.FACEBOOK}`,
  marketingGoogle: () => `${routes.marketing()}/${Routes.GOOGLE}`,
  marketingTikTok: () => `${routes.marketing()}/${Routes.TIKTOK}`,
  marketingKlaviyo: () => `${routes.marketing()}/${Routes.KLAVIYO}`,
  marketingRecharge: () => `${routes.marketing()}/${Routes.RECHARGE}`,
  marketingGoogleAnalytics: () => `${routes.marketing()}/${Routes.GOOGLE_ANALYTICS}`,
  marketingGoogleAnalytics4: () => `${routes.marketing()}/${Routes.GOOGLE_ANALYTICS_4}`,
  marketingSEO: () => `${routes.marketing()}/${Routes.SEO}`,
  // FINANCE
  finance: () => `/${Routes.FINANCE}`,
  // LTV
  ltv: () => `/${Routes.LTV}`,
  ltvOverview: () => `${routes.ltv()}/${Routes.OVERVIEW}`,
  ltvCohorts: () => `${routes.ltv()}/${Routes.COHORTS}`,
  // SETTINGS
  settings: () => `/${Routes.SETTINGS}`,
  settingsGeneral: () => `${routes.settings()}/${Routes.GENERAL}`,
  settingsBranding: () => `${routes.settings()}/${Routes.BRANDING}`,
  settingsEditGoals: () => `${routes.settings()}/${Routes.EDIT_GOALS}`,
  settingsConnections: () => `${routes.settings()}/${Routes.CONNECTIONS}`,
  settingsNotifications: () => `${routes.settings()}/${Routes.NOTIFICATIONS}`,
  settingsTeam: () => `${routes.settings()}/${Routes.TEAM}`,
  settingsAccount: () => `${routes.settings()}/${Routes.ACCOUNT}`,
  // SETTINGS COSTS
  settingsCosts: () => `${routes.settings()}/${Routes.COSTS}`,
  settingsCostsProducts: () => `${routes.settingsCosts()}/${Routes.PRODUCTS}`,
  settingsCostsShipping: () => `${routes.settingsCosts()}/${Routes.SHIPPING}`,
  settingsCostsFulfillment: () => `${routes.settingsCosts()}/${Routes.FULFILLMENT}`,
  settingsCostsMarkets: () => `${routes.settingsCosts()}/${Routes.MARKETS}`,
  settingsCostsTransactionFees: () => `${routes.settingsCosts()}/${Routes.TRANSACTION_FEES}`,
  settingsCostsMarketingCosts: () => `${routes.settingsCosts()}/${Routes.MARKETING_COSTS}`,
  // SETTINGS BUSINESS COSTS
  settingsBusinessCosts: () => `${routes.settings()}/${Routes.BUSINESS_COSTS}`,
  settingsBusinessCostsStaff: () => `${routes.settingsBusinessCosts()}/${Routes.STAFF}`,
  settingsBusinessCostsOtherCosts: () => `${routes.settingsBusinessCosts()}/${Routes.OTHER_COSTS}`,
  settingsBusinessCostsDefault: () => `${routes.settingsBusinessCosts()}/${Routes.DEFAULTS}`,
  // GOALS_WIZARD
  goalsWizard: () => `/${Routes.GOALS_WIZARD}`,
  // LOGIN
  login: () => `/${Routes.LOGIN}`,
  loginRecovery: () => `${routes.login()}/${Routes.RECOVERY}`,
  // REGISTER
  register: () => `/${Routes.REGISTER}`,
  // ONBOARDING
  onboarding: () => `/${Routes.ONBOARDING}`,
};
